import { authFetch, authHeaders, resolveApiBaseUrl } from '../auth';
import { apiUrl } from './http';

export const reportsMethods = {
  async getBookSalesReport({
    dateFrom,
    dateTo,
    search,
    includeDaily = true,
    tz = 'Asia/Kolkata',
    orderScope = 'shipping',
  } = {}) {
    try {
      const params = new URLSearchParams();
      if (dateFrom) params.set('date_from', dateFrom);
      if (dateTo) params.set('date_to', dateTo);
      if (search && String(search).trim()) params.set('search', String(search).trim());
      params.set('include_daily', includeDaily ? 'true' : 'false');
      params.set('tz', tz);
      params.set('order_scope', ['all', 'shipping', 'digital'].includes(orderScope) ? orderScope : 'shipping');
      const base = resolveApiBaseUrl();
      const url = `${apiUrl(base, 'book-sales/')}?${params.toString()}`;
      const response = await authFetch(url, {
        method: 'GET',
        headers: authHeaders({ 'Content-Type': 'application/json' }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      return { success: result.success !== false, ...result };
    } catch (error) {
      console.error('Book sales report failed:', error);
      return { success: false, error: error.message, rows: [], daily: [], totals: {} };
    }
  },

  /** Product id + title for filters (Shopify cursor pagination). */
  async getProductsList({ pageSize = 250, maxPages = 15 } = {}) {
    try {
      const base = resolveApiBaseUrl();
      const all = [];
      let pageInfo = null;
      for (let i = 0; i < maxPages; i += 1) {
        const params = new URLSearchParams();
        params.set('limit', String(pageSize));
        if (pageInfo) params.set('page_info', pageInfo);
        const url = `${apiUrl(base, 'products/')}?${params.toString()}`;
        const response = await authFetch(url, {
          method: 'GET',
          headers: authHeaders({ 'Content-Type': 'application/json' }),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        const products = data.products || [];
        for (const p of products) {
          const id = p.id ?? p.shopify_id;
          if (id == null) continue;
          const title = (p.title || '').trim();
          if (!title) continue;
          all.push({ id: String(id), title });
        }
        pageInfo = data.next_page_info || null;
        if (!pageInfo || products.length === 0) break;
      }
      all.sort((a, b) => a.title.localeCompare(b.title));
      return { success: true, products: all };
    } catch (error) {
      console.error('getProductsList failed:', error);
      return { success: false, products: [], error: error.message };
    }
  }
};
